import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  liRoot: {
    alignItems: "center",
    width: "100%",
    height: 76,
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.lines.divisionLight}`,
    margin: theme.spacing(1, 0),
    cursor: "pointer"
  },
  liItemWrapper: {
    width: "75%",
    // background: theme.palette.jamii.yellow,
    flexDirection: "column",
    justifyContent: "center",
    "& span": {
      margin: theme.spacing(0.25, 0),
      fontSize: theme.typography.body1.fontSize
    }
  },

  liTitle: {
    width: "100%",
    display: "inline-block",
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.jamii.mildBlue
  },
  liValue: {},

  liImageWrapper: {
    width: 44,
    height: 44,
    marginRight: theme.spacing(1),
    borderRadius: "50%",
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundImage: ({ image }) => image && `url(${image})`,
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxShadow: theme.shadows[3],
    background: "white"
  }
}));
